export enum EnumEstadoEquipo {
    Activo = 1,
    Suspendido = 2,
    SinContrato = 3,
    MantenimientoACosto = 4,
    EquipoEnReparacion = 5,
    EquipoEnMora = 6,
    OrdenCompraOK = 7,
    EquipoEnFabricacion = 8,
    Transito = 9,
    EquipoEnObra = 10,
    Preinstalacion = 11,
    Instalacion = 12,
    Calidad = 13,
    CertificacionEntregada = 14
}